var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "500px" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [_vm._v("Trigger Wonder")]),
          ]),
          _c(
            "v-row",
            { staticClass: "px-2 px-md-6" },
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("r-item-dropdown", {
                    attrs: { model: _vm.model.platform, label: "Platform" },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.model, "platform", $event)
                      },
                    },
                  }),
                  _c("r-item-dropdown", {
                    attrs: { model: _vm.model.item, label: "Item" },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.model, "item", $event)
                      },
                    },
                  }),
                  _c("r-currency-kind-dropdown", {
                    attrs: { model: _vm.model.currency, label: "Currency" },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.model, "currency", $event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }